<div class="guided-tour">
  <header>
    <div class="flex justify-flex-end">
      <app-col cols="auto">
        <div class="flex align-center">
          <ng-content select="[dialog-header-action]"></ng-content>
          <button mat-icon-button mat-dialog-close [autofocus]="false" tabindex="-1" class="dialog-layout__icon-button" type="button">
            <app-icon class="text-300" name="close-circle"></app-icon>
          </button>
        </div>
      </app-col>
    </div>
  </header>

  <section class="pos-relative">
    <img src="assets/images/guide-tour.svg" alt="pguide-tour-image" class="w-100" />
  </section>

  <section class="text-center mb-3 px-8">
    <h5 class="tex-900 m-0 weight-medium py-2 text-ellipsis-1 h5 mb-1 guided-tour__title">{{data?.title}}</h5>
    <p
      class="text-900 text-ellipsis-2 h6 text-center line-height-5"
      [matTooltip]="data?.message?.length > 300 ? data?.message : ''"
      [matTooltipPosition]="'left'"
    >
      {{data?.message}}
    </p>
  </section>

  <mat-dialog-actions class="flex justify-center" #actions>
    <div class="flex justify-space-between mb-1">
      <button
        mat-dialog-close
        mat-flat-button
        tabindex="-1"
        [autofocus]="false"
        class="text-primary brd brd-primary-lighter py-5 px-6 h6 d-flex bg-white align-center mr-6"
      >
        <app-icon name="close-circle" size="sm" class="text-primary mr-2"></app-icon>
        {{ 'shared.SkipTour' | translate }}
      </button>
      <button mat-flat-button  class="bg-primary text-white py-5 px-6 h6 d-flex align-center" (click)="takeTour.emit()">
        <app-icon name="play" size="sm" class="text-white mr-2"></app-icon>
        {{ 'shared.StartTour' | translate }}
      </button>
    </div>
  </mat-dialog-actions>
  <div class="text-center small text-700 pb-6">{{ 'shared.TourHelpMessage' | translate }}</div>
</div>
